<template>
  <overview-section-card>
    <v-card-title class="pb-2">
      <span class="overview-section-title">{{ $t('overview.tasks') }}</span>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <task-list :tasks="tasks"></task-list>
        </v-col>
      </v-row>
    </v-card-text>
  </overview-section-card>
</template>

<script>
import TaskList from '@/components/tasks/TaskList';
import OverviewSectionCard from '@/components/overview/OverviewSectionCard.vue';

export default {
  name: 'ProjectTasks',
  components: { TaskList, OverviewSectionCard },
  props: {
    'tasks': { required: true },
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
}
</script>

<style scoped>

</style>
